/**
 * Other Reports menu — legacy Blade reports migrated to React under Reports → Other Reports.
 * Keep alphabetical by title so sidebar and catalog stay aligned.
 */
export const OTHER_REPORTS = [
  { slug: 'alltransactions', title: 'All Transactions', route: '/other-reports/alltransactions' },
  { slug: 'bag_statement', title: 'Bag Collection Report', route: '/other-reports/bag_statement' },
  { slug: 'bank_statement', title: 'Bank Statement', route: '/other-reports/bank_statement', dedicated: true },
  { slug: 'closing_cash_statement', title: 'Closing Cash Report', route: '/other-reports/closing_cash_statement' },
  { slug: 'vehicle_statements', title: 'Customer Vehicle Wise Statement', route: '/other-reports/vehicle_statements' },
  { slug: 'exp_statement', title: 'Expense Statement', route: '/other-reports/exp_statement' },
  { slug: 'fuel_purchase', title: 'Fuel Purchase Statement', route: '/other-reports/fuel_purchase' },
  { slug: 'fuel_sales', title: 'Fuel Sales Statement', route: '/other-reports/fuel_sales' },
  { slug: 'gas_purchase', title: 'Gas Purchase Statement', route: '/other-reports/gas_purchase' },
  { slug: 'gas_sales', title: 'Gas Sales Statement', route: '/other-reports/gas_sales' },
  { slug: 'gas_stock', title: 'Gas Stock Statement', route: '/other-reports/gas_stock' },
  { slug: 'gst_setoff', title: 'GST SETOFF Statement', route: '/other-reports/gst_setoff' },
  { slug: 'nozzle_report', title: 'Nozzle Report', route: '/other-reports/nozzle_report', dedicated: true },
  { slug: 'other_income_statement', title: 'Other Income Statement', route: '/other-reports/other_income_statement', dedicated: true },
  { slug: 'ownerfunds_statement', title: 'Owners Fund Statement', route: '/other-reports/ownerfunds_statement' },
  { slug: 'stock_report', title: 'Stock Gain/Loss Statement', route: '/other-reports/stock_report' },
  { slug: 'fuel_ps', title: 'Tankwise Purchase Sales Statement', route: '/other-reports/fuel_ps' },
];

export const otherReportBySlug = (slug) =>
  OTHER_REPORTS.find((report) => report.slug === slug) || null;

export default OTHER_REPORTS;
